import React, { useEffect, useState } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png'
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
    const [tienda, setTienda] = useState([]);

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };
 const year = new Date().getFullYear();
    return (
        <footer className='FooterContain'>
            <div className='footer-profile'>
                
                <div className='footer-profile-info'>
                    <Anchor to='/' className='footer-profile-logo'>
                        {tienda?.imagen1 ? (
                            <img src={tienda?.imagen1} alt="logo" />
                        ) : (
                            <img src={logo} alt="logo" />
                        )}
                    </Anchor>
                    {tienda?.nombre ? (
                        <h2 className='footer-store-name'>{tienda?.nombre}</h2>
                    ) : (
                        <h2 className='footer-store-name'>Mi Tienda</h2>
                    )}
                    {tienda?.eslogan && (
                        <p className='footer-slogan'>{tienda.eslogan}</p>
                    )}
                </div>
            </div>

            <div className='footer-body'>
                <div className='footer-contact-row'>
                    {tienda?.email && (
                        <Anchor to={`mailto:${tienda.email}`} target="_blank" className='footer-contact-item'>
                            <FontAwesomeIcon icon={faEnvelope} />
                            <span>{tienda.email}</span>
                        </Anchor>
                    )}
                    {tienda?.direccion && (
                        <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target="_blank" className='footer-contact-item'>
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                            <span>{tienda.direccion}</span>
                        </Anchor>
                    )}
                    {tienda?.telefono && (
                        <Anchor to={`tel:${tienda.telefono}`} target="_blank" className='footer-contact-item'>
                            <FontAwesomeIcon icon={faPhone} />
                            <span>{tienda.telefono}</span>
                        </Anchor>
                    )}
                </div>

                <div className='footer-socials-row'>
                    {tienda?.instagram && (
                        <Anchor to={tienda.instagram} target="_blank" className='footer-contact-item' aria-label="Instagram">
                            <i className='fa fa-instagram'></i>
                            <span>Instagram</span>
                        </Anchor>
                    )}
                    {tienda?.telefono && (
                        <Anchor to={`tel:${tienda.telefono}`} target="_blank" className='footer-contact-item' aria-label="WhatsApp">
                            <i className='fa fa-whatsapp'></i>
                            <span>WhatsApp</span>
                        </Anchor>
                    )}
                    {tienda?.facebook && (
                        <Anchor to={tienda.facebook} target="_blank" className='footer-contact-item' aria-label="Facebook">
                            <i className='fa fa-facebook'></i>
                            <span>Facebook</span>
                        </Anchor>
                    )}
                </div>
               
            </div>

            

        </footer>
    );
}
